import * as React from 'react'
import { cn } from 'app/lib/utils'
import { NavTabs, type TabType } from 'app/components/ui/nav-tabs'

export type PageHeaderComponentProps = {
  className?: string
  title: string
  subTitle?: string
  itemsText?: string
  primaryButtonSlot?: React.ReactElement
  secondaryButtonSlot?: React.ReactElement
  otherButtons?: React.ReactElement[]
  tabs?: TabType[]
  learnMore?: React.ReactElement
}

export function PageHeaderComponent({
  className,
  title,
  subTitle,
  itemsText,
  primaryButtonSlot,
  secondaryButtonSlot,
  otherButtons,
  tabs,
  learnMore,
}: PageHeaderComponentProps): React.ReactElement {
  return (
    <>
      <div
        className={cn(
          // md:gap-0 — desktop had no gap between the title block and actions.
          'flex flex-col gap-4 pb-6 md:flex-row md:items-center md:justify-between md:gap-0 md:pb-8',
          className,
        )}
      >
        <div className="flex items-center gap-3">
          <div>
            <h1 className="gilroy text-heading-xl text-strong">{title}</h1>
            {subTitle && <p className="mt-2 text-heading-md text-subtle">{subTitle}</p>}
          </div>
          {itemsText && (
            <div className="flex items-center justify-center rounded border-[0.5px] border-default bg-gray-minimal px-1.5 py-0.5 text-label-xs text-gray-strong">
              {itemsText}
            </div>
          )}
          {learnMore && <div className="items-baseline">{learnMore}</div>}
        </div>
        <div className="flex flex-wrap items-center gap-3 md:flex-nowrap md:gap-4">
          {otherButtons?.map((button, i) => (
            <div key={i}>{button}</div>
          ))}
          {secondaryButtonSlot}
          {primaryButtonSlot}
        </div>
      </div>
      {tabs && (
        <div className="overflow-x-auto">
          <NavTabs tabs={tabs} />
        </div>
      )}
    </>
  )
}
